<template>
  <v-layout row wrap white>
    <v-flex xs4 ml-5>
      <v-text-field
        v-model="name"
        label="Procurar checklist"
        append-icon="search"
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "SearchChecklists",

  props: {
    searchServices: Function
  },

  data() {
    return {
      name: ""
    };
  },

  methods: {
    search() {
      this.$props.searchServices({ name: this.name });
    }
  }
};
</script>

<style>
</style>